import { Component, OnInit, Input, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';

enum MultiSelectOptionsTypes {
  checkbox,
  func
}

export interface MultiSelectOptions {
  value: string;
  id: number;
  type: MultiSelectOptionsTypes.checkbox;
  func?: () => {};
  checked?: boolean;
}
@Component({
  selector: 'app-multi-selection-tags',
  templateUrl: './multi-selection-tags.component.html',
  styleUrls: ['./multi-selection-tags.component.scss']
})
export class MultiSelectionTagsComponent implements OnInit {

  @Input() tags = [];
  @Input() options: MultiSelectOptions[] = [];
  @Input() disabled = false;
  @Input() id = '';
  @Input() value = '';
  @Input() invalid = false;
  @Input() title = '';
  @Output() changed = new EventEmitter<any>();
  isOpen = false;

  constructor(private eRef: ElementRef) { }

  ngOnInit() {
    for (const tag of this.tags) {
      tag.checked = true;
      for (const opt of this.options) {
        if (opt[this.value] === tag[this.value]) {
          opt.checked = true;
        }
      }
    }
    this.updateList();
  }


  @HostListener('document:click', ['$event'])
  onClick(ev) {
    if (this.isOpen) {
      if (!this.eRef.nativeElement.contains(ev.target)) {
        this.isOpen = false;
      }
    }
  }

  openDropdown() {
    this.isOpen = !this.isOpen;
  }

  checkItem(option, i) {
    const aux = this.tags.find(tag => tag[this.value] === option[this.value]);
    if (this.tags.indexOf(aux) < 0) {
      this.addOption(option, i);
    } else {
      this.removeOption(option);
    }
    this.updateList();
  }

  removeOption(option) {
    const aux = this.tags.find(tag => tag[this.value] === option[this.value]);
    this.tags.splice(this.tags.indexOf(aux), 1);
    option.checked = false;
  }

  addOption(option, index) {
    this.tags.splice(index, 0, option);
    option.checked = true;
  }

  removeTag(tag) {
    const aux = this.options.find(opt => opt[this.value] === tag[this.value]);
    this.removeOption(aux);
    this.updateList();
  }

  updateList() {
    this.changed.emit(this.tags);
  }
}
